export default __webpack_public_path__ + "static/media/hero_image.af51fb61.jpg";